// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"eb5d2d4a","453":"6d52a291","551":"6e48fa61","707":"d12d723e"}[chunkId] + ".chunk.js";
};